import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=6ba5b2f5&scoped=true"
import script from "./product-info.vue?vue&type=script&lang=js"
export * from "./product-info.vue?vue&type=script&lang=js"
import style0 from "./product-info.vue?vue&type=style&index=0&id=6ba5b2f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5b2f5",
  null
  
)

export default component.exports